/**
 * Brand image assets — single home for the Royale crown glyph paths.
 *
 * Black crown on light surfaces, white crown on dark. Imported wherever the
 * crown renders (sheets, login, invite bubble, welcome/signup) so a future
 * asset rename is a one-line change.
 */
export const CROWN_BLACK = `${process.env.PUBLIC_URL}/images/royale-crown-black_150.png`;
export const CROWN_WHITE = `${process.env.PUBLIC_URL}/images/royale-crown-white_150.png`;

// Small white crown (96px source, 96x60 — NOT square; size by width and let
// the height follow, or the crown crunches). Used in the Get-Royale banner's
// tile. Separate export rather than reusing CROWN_WHITE because the 150px
// asset is a different aspect and the tile is 24px wide.
export const CROWN_WHITE_SMALL = `${process.env.PUBLIC_URL}/images/royale-crown-white-96.png`;
